<ng-container *ngVar="(bewepr$ | async) as bewepr">
  <ng-container *ngVar="(beweau$ | async) as beweau">
    <div class="flex flex-row-reverse flex-wrap lg:flex-nowrap">
      <div *ngVar="(zusatzdaten$ | async) as zusatzdaten" class="text-right ml-4">
        @if (bewepr?.barcode) {
          <soft-barcode labelType="code39" [data]="bewepr.barcode"></soft-barcode>
        }
        <p class="mt-2 whitespace-nowrap">
          <span class="font-semibold whitespace-nowrap">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.RHD' | translate}}:</span>
          {{zusatzdaten?.rhd ?? '-'}}
        </p>
        <p class="mt-2">
          <span class="font-semibold">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.STUECKELUNG' | translate}}:</span>
        {{zusatzdaten?.stueckelung ?? '-'}}</p>
        <p class="mt-2">
          <span class="font-semibold">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.CHARGE' | translate}}:</span>
        {{bewepr?.chargeBean?.chargennummer ?? '-'}}</p>
        <p class="mt-2">
          <span class="font-semibold">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.PLU' | translate}}:</span>
        {{zusatzdaten?.plu ?? '-'}}</p>
      </div>
      <div class="g gtc-2 gtr-4 gap w-full mt-4 lg:mt-0 grid-flow-row-dense auto-rows-auto">
        <div class="soft-card gc-1 gr-1">
          <div class="soft-overline">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.KUNDE' | translate}}</div>
          <div class="mt-2 color-light">{{beweau?.kopfauBean?.kundenBean?.nummer ?? '-'}}</div>
          @if ((beweau?.kopfauBean?.kundenBean?.erp_kundennummer?.length || 0) > 0) {
            <div class="mt-2 text-sm">{{beweau?.kopfauBean?.kundenBean?.erp_kundennummer ?? '-'}}</div>
          }
          <div class="mt-2 font-semibold">{{beweau?.kopfauBean?.kundenBean?.kurzbez}}</div>
        </div>
        <div class="soft-card gc-1 gr-2">
          <span class="soft-overline">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.ARTIKEL' | translate}}</span>
          <div class="mt-2 color-light">{{bewepr?.artikelBean?.fertigartikelnummer ?? '-'}}</div>
          <div class="mt-2 font-semibold">{{bewepr?.artikelBean?.fertigartikelbez}}</div>
        </div>
        <div class="soft-card gc-2 gr-1-2 ">
          <span class="soft-overline">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.AUFTRAG.TITLE' | translate}}</span>
          <div class="flex justify-between mt-2 flex-col sm:flex-row border-b border-b-solid border-gray-100 sm:border-none pb-1 sm:pb-0">
            <span>{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.AUFTRAG.NUMMER' | translate}}</span>
            <span class="font-semibold">{{beweau?.kopfauBean?.auftragsnummer ?? '-'}}</span>
          </div>
          <div class="flex justify-between mt-2 flex-col sm:flex-row border-b border-b-solid border-gray-100 sm:border-none pb-1 sm:pb-0">
            <span>{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.AUFTRAG.AUFTRAGSDATUM' | translate}}</span>
            <span class="font-semibold">{{(beweau?.kopfauBean?.belegdatum ?? '-') | format:'DATE.DEFAULT'}}</span>
          </div>
          <div class="flex justify-between mt-2 flex-col sm:flex-row border-b border-b-solid border-gray-100 sm:border-none pb-1 sm:pb-0">
            <span>{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.AUFTRAG.STATUS.LABEL' | translate}}</span>
            <span class="font-semibold">{{beweau?.kopfauBean?.auftragsstatus ? ('#PRODUKTIONSAUFTRAG.PAGES.DETAIL.AUFTRAG.STATUS.' + $safeNavigationMigration(beweau?.kopfauBean?.auftragsstatus) | translate) : '-'}}</span>
          </div>
          <div class="flex justify-between mt-2 flex-col sm:flex-row border-b border-b-solid border-gray-100 sm:border-none pb-1 sm:pb-0">
            <span>{{'Prod.-Nummer' | translate}}</span>
            <span class="font-semibold">{{bewepr?.kopfprBean?.belegnummerPr }}</span>
          </div>
          <div class="flex justify-between mt-2 flex-col sm:flex-row border-b border-b-solid border-gray-100 sm:border-none pb-1 sm:pb-0">
            <span>{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.AUFTRAG.MENGE' | translate}}</span>
            <span class="text-right">
              <span class="font-semibold whitespace-nowrap">{{($safeNavigationMigration(beweau?.erfmenge) | format:'NUMBER.DECIMAL_3') ?? '-'}} {{beweau?.arteh_lfBean?.eh}}</span>
              <br />
              <span class="font-semibold whitespace-nowrap">{{($safeNavigationMigration(beweau?.verrmenge) | format:'NUMBER.DECIMAL_3') ?? '-'}} {{beweau?.arteh_verBean?.eh}}</span>
            </span>
          </div>
          <div class="flex justify-between mt-2 flex-col sm:flex-row border-b border-b-solid border-gray-100 sm:border-none pb-1 sm:pb-0">
            <span>{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.AUFTRAG.PROD_DATUM' | translate}}</span>
            <span class="font-semibold">{{(bewepr?.produktionsdatum  ?? '-') | format:'DATE.DEFAULT'}}</span>
          </div>
          <div class="flex justify-between mt-2 flex-col sm:flex-row sm:pb-0">
            <span>{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.AUFTRAG.LINIE' | translate}}</span>
            <span class="font-semibold">{{bewepr?.maschineBean?.maschinenr ?? '-'}}</span>
          </div>
        </div>
        <div class="soft-card gc-1-2 gr-3">
          <div class="soft-overline">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.ZEILENTEXT' | translate}}</div>
          <div class="mt-2">{{beweau?.zeilentext ?? bewepr?.zeilentext ?? '-'}}</div>
        </div>
        <div class="soft-card gc-1-2 gr-4">
          <div class="soft-overline">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.ARTIKELINFORMATION' | translate}}</div>
          <div class="mt-2">{{bewepr?.artikelBean?.artikelinformationen ?? '-'}}</div>
        </div>
      </div>
    </div>

    <ng-container *ngVar="(rezeptliste$ |async) as rezeptliste">
      @if ((rezeptliste?.rezeptBean?.length ?? 0) > 0) {
        <div class="mt-8 mb-4 pb-4">
          <div class="text-lg font-semibold">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.REZEPTUREN.HEADER' | translate}}</div>
          @for (rezept of rezeptliste.rezeptBean; track rezept) {
            <div class="soft-card mt-2 w-full text-sm">
              <table class="w-full">
                <thead>
                  <tr class="border-b border-solid border-gray-200">
                    <th class="soft-overline text-left py-2">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.REZEPTUREN.OVERLINE' | translate}} {{rezept.bezeichnung}}</th>
                    <th class="text-xs color-light text-right py-2">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.REZEPTUREN.SCAN_MENGE' | translate}}</th>
                    <th class="text-xs color-light text-right py-2">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.REZEPTUREN.RESERVIERTE_MENGE' | translate}}</th>
                    <th class="text-xs color-light text-right py-2">{{'#PRODUKTIONSAUFTRAG.PAGES.DETAIL.REZEPTUREN.SOLL_MENGE' | translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (bewe of rezept.rezepturbewegungBean; track bewe) {
                    <tr class="border-b border-solid border-gray-200 last:border-b-0">
                      <td class="text-left py-2">
                        <div class="color-light">{{bewe.artikelbean?.fertigartikelnummer}}</div>
                        <div class="font-semibold">{{bewe.artikelbean?.fertigartikelbez}}</div>
                      </td>
                      <td class="text-right py-2" style="width: 8rem">{{ (bewe?.ver_Menge ?? bewe?.vermenge ?? 0) | format:'NUMBER.DECIMAL_3' }} {{bewe?.einheit_scan?.eh  || ''}}</td>
                      <td class="text-right py-2" style="width: 8rem">{{bewe.reservierte_menge ?? 0 | format:'NUMBER.DECIMAL_3'}} {{bewe.einheit_reserviert?.eh}}</td>
                      <td class="font-semibold text-right py-2"  style="width: 8rem">{{bewe.soll_menge ?? bewe?.sollMenge ?? 0 | format:'NUMBER.DECIMAL_3'}} {{bewe.einheit?.eh}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      }
    </ng-container>
  </ng-container>
</ng-container>

